import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', // Make the service available application-wide
})
export class OtpService {
  private otpStatusSubject = new BehaviorSubject<boolean>(false);
  otpStatus$ = this.otpStatusSubject.asObservable(); // Expose as Observable

  /**
   * Sets the OTP status.
   * @param isSubmitted - A boolean indicating whether the OTP has been submitted.
   */

  setOtpStatus(isSubmitted: boolean): void {
    this.otpStatusSubject.next(isSubmitted);
  }



  /**
   * Retrieves the current OTP status.
   * @returns A boolean indicating whether the OTP has been submitted.
   */
  getOtpStatus(): boolean {
    return this.otpStatusSubject.value;
  }
}